export default "__VITE_PUBLIC_ASSET__19334a4d__"